export default __webpack_public_path__ + "static/media/spices.ef967199.PNG";